export const PUBLICATION_DESTINATION_PICKER_CONSTS = {
  commentsMsg: 'Комментарии',
  inZenBlogsMsg: 'В Дзен Блоги',
  inZenNewsMsg: 'В Дзен Новости',
  onlyWithPhotoNotFromPhotoBankMsg: 'Только с картинками не из фотобанка',
  yandexDzenTitle: 'Заголовок для Дзен.Блогов',
  yandexDzenTitleMaxErrorLength: 140,
  yandexDzenTitleMaxWarningLength: 80
}
